import { environment } from '../../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').factory('ClientCommissionSeasonService', ClientCommissionSeasonService);

  ClientCommissionSeasonService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function ClientCommissionSeasonService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'clients';

    var service = {
      getClientCommissionSeason: getClientCommissionSeason,
      saveClientCommissionSeason: saveClientCommissionSeason,
      changeClientCommissionSeasonStatus: changeClientCommissionSeasonStatus,
      deleteClientCommissionSeason: deleteClientCommissionSeason,
      saveGeneralSettings: saveGeneralSettings,
      setGeneralSettings: setGeneralSettings,
      groupGeneralSettingsByPriceList: groupGeneralSettingsByPriceList,
    };

    return service;

    ////////////////

    function getClientCommissionSeason(clientCommissionSeason, clientId) {
      var url = apiUrl + '/' + clientId + '/client_commission_seasons/' + clientCommissionSeason.id;

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveClientCommissionSeason(clientCommissionSeason, clientId) {
      var url = apiUrl + '/' + clientId + '/client_commission_seasons';

      var method = clientCommissionSeason.id ? 'put' : 'post';
      url = clientCommissionSeason.id ? url + '/' + clientCommissionSeason.id : url;

      function success(response) {
        var addedMsg = $translate('CLIENT_COMMISSION_SEASON_ADDED');
        var modifiedMsg = $translate('CLIENT_COMMISSION_SEASON_MODIFIED');
        var msg = !clientCommissionSeason.id ? addedMsg : modifiedMsg;
        utils._successMsg(msg);

        return response.data;
      }

      function failure(response) {
        utils._errorMsg(response.data.error);

        return false;
      }

      return RestResource.request(
        method,
        url,
        { client_commission_season: clientCommissionSeason },
        success,
        failure
      );
    }

    function changeClientCommissionSeasonStatus(clientCommissionSeason, clientId) {
      var url = apiUrl + '/' + clientId + '/client_commission_seasons/' + clientCommissionSeason.id;

      var params = { title: null };

      if (clientCommissionSeason.status === 'active') {
        params.title = 'DEACTIVATE_CLIENT_COMMISSION_SEASON';
        // params.body = 'DEACTIVATING_CLIENT_COMMISSION_SEASON_WARNING';
      }

      utils.changeItemStatus(url, clientCommissionSeason, params);
    }

    function deleteClientCommissionSeason(
      clientCommissionSeason,
      clientId,
      successCallback,
      index
    ) {
      var url = apiUrl + '/' + clientId + '/client_commission_seasons/' + clientCommissionSeason.id;

      var params = {
        title: 'SURE_TO_DELETE_CLIENT_COMMISSION_SEASON',
        //body:       'DELETING_CLIENT_COMMISSION_SEASON_WARNING',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'CLIENT_COMMISSION_SEASON_DELETED',
      };

      utils.deleteItem(url, successCallback, params, index);
    }

    function saveGeneralSettings(generalSettings, clientId, clientCommissionSeasonId) {
      var url = apiUrl + '/' + clientId + '/client_commission_seasons/' + clientCommissionSeasonId;
      url += '/client_commission_general_settings/update_settings';

      function success(response) {
        utils._successMsg($translate('DISCOUNTS_UPDATED'));

        return response.data;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);

        return false;
      }

      return RestResource.request(
        'put',
        url,
        { general_settings: generalSettings },
        success,
        failure
      );
    }

    function setGeneralSettings(clientCommissionGeneralSettings, priceLists) {
      var generalOptions = [
        {
          name: $translate('GENERAL'),
          icon: 'tag',
          percentage_type: 'general_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('TOUR'),
          icon: 'binoculars',
          percentage_type: 'tour_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('TRANSPORTATION'),
          icon: 'truck',
          percentage_type: 'transportation_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('HOTEL'),
          icon: 'building',
          percentage_type: 'hotel_percentage',
          min: 0,
          max: 100,
        },
      ];

      clientCommissionGeneralSettings = clientCommissionGeneralSettings || [];

      var generalSettings = [];
      generalOptions.forEach(function (generalOption) {
        var settingsByPriceList = [];

        priceLists.forEach(function (priceList) {
          var settingId;
          var percentage = 0;

          for (var i = 0; i < clientCommissionGeneralSettings.length; i++) {
            var generalSetting = clientCommissionGeneralSettings[i];

            if (generalSetting.price_list_id === priceList.id) {
              settingId = generalSetting.id;
              percentage = generalSetting[generalOption.percentage_type];
              break;
            }
          }

          var priceListSetting = {
            percentage_type: generalOption.percentage_type,
            min: generalOption.min,
            max: generalOption.max,
            price_list_id: priceList.id,
            id: null,
          };

          priceListSetting[generalOption.percentage_type] = percentage;

          // Exists
          if (settingId) {
            priceListSetting.id = settingId;
          }

          settingsByPriceList.push(priceListSetting);
        });

        var setting = {
          name: generalOption.name,
          icon: generalOption.icon,
          settingsByPriceList: settingsByPriceList,
        };

        generalSettings.push(setting);
      });

      return generalSettings;
    }

    // In case whe want to save in bulk (embeds_many)
    function groupGeneralSettingsByPriceList(generalSettings) {
      var settingsByPriceList = [];

      generalSettings.forEach(function (generalSetting) {
        var identifier;
        generalSetting.settingsByPriceList.forEach(function (priceListSetting) {
          identifier = priceListSetting.price_list_id;

          if (!settingsByPriceList[identifier]) {
            settingsByPriceList[identifier] = {
              price_list_id: priceListSetting.price_list_id,
            };

            if (priceListSetting.id) {
              settingsByPriceList[identifier].id = priceListSetting.id;
            }
          }

          settingsByPriceList[identifier][priceListSetting.percentage_type] =
            priceListSetting[priceListSetting.percentage_type];
        });
      });

      return utils.removeKeyFromArrayObject(settingsByPriceList);
    }
  }
})();
